import type { HyperLiquidWsMeta } from "@tradingApp/api/types/HyperLiquid";
import type { TradingPerpAsset } from "@tradingApp/Providers/TradingProvider/types";
import type { AssetCtx } from "hyperliquid";

export function tradingMergeMetaAndAssetCtxs(
  meta: HyperLiquidWsMeta,
  assetCtx: AssetCtx[],
): TradingPerpAsset[] {
  const { universe } = meta;
  const perpAssets: TradingPerpAsset[] = [];

  for (let i = 0; i < universe.length; i += 1) {
    const assetMeta = universe[i];
    const asset = assetCtx[i];

    perpAssets.push({ ...assetMeta, ...asset });
  }

  return perpAssets;
}
